module.exports = __webpack_public_path__ + "img/reward-diamond.286634b3.png";